/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flat_Novel_Camel_WishInputs */

const fr_flat_novel_camel_wish = /** @type {(inputs: Flat_Novel_Camel_WishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aujourd'hui`)
};

/**

* @param {Flat_Novel_Camel_WishInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const flat_novel_camel_wish = /** @type {((inputs?: Flat_Novel_Camel_WishInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_Novel_Camel_WishInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_flat_novel_camel_wish(inputs)
});